// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_userinfo.scss
// module id = 60
// module chunks = 0